import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CrosswalkPath from './CrosswalkPath';
import { CrosswalkColors } from './const';
import useCrosswalkStyles from './styles';
import { CrosswalkProps } from './types';
import { getCrosswalkAnchorPoint } from './util';
import { useKineticMapLiveProjection } from 'components/maps/MapContext/hooks/useKineticMap';

export const Crosswalk: React.FunctionComponent<CrosswalkProps> = ({
  crosswalk,
  coordinates,
  selected,
  onClickConnect,
  connectable,
  disabled,
  onClickCrosswalk,
  onMouseOut,
  onMouseOver,
}) => {
  const { anchorCoordinates } = useMemo(
    () => getCrosswalkAnchorPoint(crosswalk, coordinates),
    [crosswalk, coordinates]
  );

  const { t } = useTranslation('signals');
  const color = selected ? CrosswalkColors.BLUE : CrosswalkColors.ORANGE;
  const classes = useCrosswalkStyles();

  const point = useKineticMapLiveProjection([...anchorCoordinates]);

  const buttonPosition = crosswalk.id ? point : null;

  if (!crosswalk?.geometry) {
    return null;
  }

  return (
    <g>
      <CrosswalkPath
        color={color}
        coordinates={crosswalk.geometry.coordinates}
        disabled={disabled}
        id={crosswalk.id}
        onClick={onClickCrosswalk}
        onMouseOut={onMouseOut}
        onMouseOver={onMouseOver}
      />
      {connectable && buttonPosition && (
        <foreignObject
          className={classes.connectButton}
          x={buttonPosition.x}
          y={buttonPosition.y + 5}
          width={60}
          height={25}
          onClick={onClickConnect}
        >
          <span>{t('connect')}</span>
        </foreignObject>
      )}
    </g>
  );
};
